@if (loading) {
	<app-loader></app-loader>
}

@if (tableList) {
	<div class="row">
		<div class="col-12">
			
			<form #tableForm="ngForm">
				<div class="row form-row">
					<div class="col-1"><label>Table </label></div>
					<div class="col-2">
						<select id="tableList" name="tableList" [(ngModel)]="tableModel.tableId"
							class="table-engine-form-control w-100 select-arrow">
							@for (table of tableList; track table) {
								<option [selected]="table.tableId == tableModel.tableId"
									value={{table.tableId}}>
									{{table.displayName}}
								</option>
							}
						</select>
					</div>
					<div class="col-1"></div>
					<div class="col-2 align-items-center">
						<button class="btn btn-modal-pos small-font hvr-shrink" type="button"
							(click)="getTableResult(true, false)">
							<span>Get Table Result</span>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
}
<app-dynamic-grid
	[gridData]="gridData"
	[isCRUDEnabled]="true"
	[canAddRow]="canAddRow"
	[canDeleteRow]="canDeleteRow"
	[filter]="tableModel.filter"
	[sort]="tableModel.sortList"
	(modelChange)="updateTableModel($event)"
	(downloadResults)="downloadTableResult()"
	(downloadAudit)="downloadAuditReport()"
	(saveRefDataChanges)="saveRefDatachanges($event)">
</app-dynamic-grid>
